import HttpGlobal from "../Global/HttpGlobal.class";
import { customerApiBaseUrl, isNativeMode } from "../../../native/nativeMode";
import { UpdatePaymentDayI } from "./Interfaces/InvoiceI.request";

export interface BillingInvoiceResponse {
  id: string;
  date: string | null;
  annuality: number | null;
  invoiceNumber: number | null;
  amount: number | null;
  status: "paid" | "failed";
  payable?: boolean;
  downloadUrl?: string;
}

export default class HttpInvoiceRepository extends HttpGlobal {
  private readonly API_URL_INVOICE:
    | string
    | undefined = `${process.env.REACT_APP_CUSTOMER_APP_URL}api/payment`;

  private readonly API_URL_BILLING:
    | string
    | undefined = `${process.env.REACT_APP_CUSTOMER_APP_URL}api/billing`;

  // Native (Portal Cliente IT): historial y descarga desde el gateway, mismo
  // contrato que api/billing/invoices del monolito.
  getReceiptUrl = async (leadId: string, invoiceId: string): Promise<string | null> => {
    const url = isNativeMode()
      ? `${customerApiBaseUrl()}/customer/leads/${leadId}/billing/invoices/${invoiceId}/receipt`
      : `${this.API_URL_BILLING}/invoices/${leadId}/receipt/${invoiceId}`;
    const response = await this.generalGet(url);
    return response?.receiptUrl ?? null;
  };

  getPaymentLink = async (leadId: string, invoiceId: string): Promise<string | null> => {
    if (isNativeMode()) {
      const response = await this.generalPost({
        url: `${customerApiBaseUrl()}/customer/leads/${leadId}/billing/invoices/${invoiceId}/payment-link`,
        dataRequest: {},
      });
      return response?.paymentLink ?? null;
    }
    const response = await this.generalGet(
      `${this.API_URL_BILLING}/invoices/${leadId}/payment-link/${invoiceId}`
    );
    return response?.paymentLink ?? null;
  };

  getBillingInvoices = async (leadId: string): Promise<BillingInvoiceResponse[]> => {
    const url = isNativeMode()
      ? `${customerApiBaseUrl()}/customer/leads/${leadId}/billing/invoices`
      : `${this.API_URL_BILLING}/invoices/${leadId}`;
    const response = await this.generalGet(url);
    return response?.invoices ?? [];
  };

  updatePaymentDay = async (leadId: string, paymentDay: number): Promise<void> => {
    const data: UpdatePaymentDayI = {
      payment_day: paymentDay
    };

    await this.generalPost({
      url: `${this.API_URL_INVOICE}/update-payment-day/${leadId}`,
      dataRequest: data,
    });
  };
}
